import React from 'react';
import { Construction } from 'lucide-react';

/**
 * Generic placeholder for menu items whose module is not built yet
 * (Finance sub-modules) or a phase still in progress.
 */
export default function ComingSoon({ title = 'This module', note }) {
  return (
    <div className="p-6 md:p-10 max-w-3xl mx-auto">
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-10 text-center">
        <div className="w-16 h-16 rounded-2xl bg-teal-50 flex items-center justify-center mx-auto mb-4">
          <Construction className="w-8 h-8 text-teal-600" />
        </div>
        <h1 className="text-2xl font-bold text-slate-800">{title}</h1>
        <p className="text-slate-500 mt-2">
          {note || `${title} is coming soon. The menu entry is in place — the module will be enabled in a later phase.`}
        </p>
      </div>
    </div>
  );
}
